<template>
  <div class="w-full lg:w-1/2 mx-auto">
    <PageHeader label="Client created successfully"></PageHeader>
    
    <div class="my-6">
      <div class="text-base leading-normal">
        {{ getAppName }} has successfully created a client based on the opportunity from Mercury.
        Please 

        <router-link
          :to="{
            name : 'application-applicant-profile',
            params : {
              clientId   : $route.params.clientId,
              applicantId: $route.params.applicantId
            }
          }"
          tag="a"
          v-on:click.stop
          class="text-blue-600">review it here</router-link>.
      </div>

      <ShareBox />
    </div>
  </div>
</template>

<script>
  import PageHeader from '@/shared/components/headers/PageHeader'
  import ShareBox   from '@/shared/components/ShareBox'

  export default {
    components: {
      PageHeader,
      ShareBox
    },
  }
</script>